<template>
  <div class="ia-pensando">
    <svg class="brain-svg" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
      <path class="brain-path" d="M184 0c30.9 0 56 25.1 56 56V456c0 30.9-25.1 56-56 56c-28.9 0-52.7-21.9-55.7-50.1c-5.2 1.4-10.7 2.1-16.3 2.1c-35.3 0-64-28.7-64-64c0-7.4 1.3-14.6 3.6-21.2C21.4 367.4 0 338.2 0 304c0-31.9 18.7-59.5 45.8-72.3C37.1 220.8 32 207 32 192c0-30.7 21.6-56.3 50.4-62.6C80.8 123.9 80 118 80 112c0-29.9 20.6-55.1 48.3-62.1C131.3 21.9 155.1 0 184 0zM328 0c28.9 0 52.6 21.9 55.7 49.9C411.4 56.9 432 82.1 432 112c0 6-.8 11.9-2.4 17.4C458.4 135.7 480 161.3 480 192c0 15-5.1 28.8-13.8 39.7C493.3 244.5 512 272.1 512 304c0 34.2-21.4 63.4-51.6 74.8c2.3 6.6 3.6 13.8 3.6 21.2c0 35.3-28.7 64-64 64c-5.6 0-11.1-.7-16.3-2.1c-3 28.2-26.8 50.1-55.7 50.1c-30.9 0-56-25.1-56-56V56c0-30.9 25.1-56 56-56z"/>
      <g class="brain-sparks">
        <circle cx="150" cy="170" r="20" class="spark spark-travel-a"/>
        <circle cx="330" cy="150" r="20" class="spark"/>
        <circle cx="200" cy="300" r="20" class="spark spark-travel-b"/>
        <circle cx="360" cy="320" r="20" class="spark"/>
        <circle cx="256" cy="410" r="20" class="spark"/>
      </g>
    </svg>
    <div class="ia-pensando-narracion">
      <span class="brain-text ia-text ia-pensando-latin">{{ latinMostrado }}</span>
      <span class="ia-pensando-texto">{{ textoMostrado }}</span>
      <span v-if="total" class="text-color-gray ia-pensando-progreso">{{ hechos }} / {{ total }}</span>
    </div>
  </div>
</template>

<script>
// Indicador "pensando" de la IA (cerebro latiendo con chispas). Mismo grafismo en todas las
// funcionalidades de IA (revisar formatos, sugerir características…) para que resulte familiar.
export default {
  name: 'rIaPensando',
  props: {
    // Objeto de narración SSE { latin, texto, hechos, total }.
    narracion: { type: Object, default: null },
    latinDefault: { type: String, default: 'Thinking' },
    textoDefault: { type: String, default: 'Procesando…' }
  },
  computed: {
    latinMostrado() { return (this.narracion && this.narracion.latin) || this.latinDefault; },
    textoMostrado() { return (this.narracion && this.narracion.texto) || this.textoDefault; },
    total() { return this.narracion ? this.narracion.total : 0; },
    hechos() { return this.narracion ? this.narracion.hechos : 0; }
  }
};
</script>

<style scoped>
.ia-pensando {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  padding: 28px;
}
.ia-pensando-narracion {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.ia-pensando-latin {
  font-size: 15px;
  font-style: italic;
}
.ia-pensando-texto {
  font-size: 13px;
  color: #333;
}
.ia-pensando-progreso {
  font-size: 11px;
}
.brain-text {
  font-size: 11px;
}
.brain-svg {
  width: 46px;
  height: 46px;
  overflow: visible;
}
.brain-path {
  fill: rgba(0, 0, 255, 0.08);
  stroke: #0000ff;
  stroke-width: 16;
  stroke-linejoin: round;
  animation: brainGlow 1.6s ease-in-out infinite;
}
@keyframes brainGlow {
  0%, 100% { stroke: #0000ff; filter: drop-shadow(0 0 1px rgba(0, 0, 255, 0.5)); }
  50%      { stroke: #3a6dff; filter: drop-shadow(0 0 5px rgba(0, 90, 255, 0.85)); }
}
.spark {
  fill: #ffffff;
  opacity: 0.12;
  transform-box: fill-box;
  transform-origin: center;
  animation: sparkFire 1.2s ease-in-out infinite;
}
.brain-sparks .spark:nth-child(1) { animation-delay: 0s; }
.brain-sparks .spark:nth-child(2) { animation-delay: 0.3s; }
.brain-sparks .spark:nth-child(3) { animation-delay: 0.6s; }
.brain-sparks .spark:nth-child(4) { animation-delay: 0.9s; }
.brain-sparks .spark:nth-child(5) { animation-delay: 1.2s; }
@keyframes sparkFire {
  0%, 100% { opacity: 0.12; filter: none; }
  45%      { opacity: 1; filter: drop-shadow(0 0 3px #7fb3ff); }
}
.spark-travel-a { animation: sparkFire 1.2s ease-in-out infinite, travelA 2.6s ease-in-out infinite; }
.spark-travel-b { animation: sparkFire 1.2s ease-in-out infinite, travelB 3.1s ease-in-out infinite; }
@keyframes travelA { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(110px, 80px); } }
@keyframes travelB { 0%, 100% { transform: translate(0, 0); } 50% { transform: translate(130px, -60px); } }
</style>
